import { render, staticRenderFns } from "./CompRadioButton.vue?vue&type=template&id=0fe71bb7&"
import script from "./CompRadioButton.vue?vue&type=script&lang=ts&"
export * from "./CompRadioButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports